import { DateTime } from "luxon";

export function getValueOrUndefined<T>(check: boolean, value: T): T | undefined {
  return check ? value : undefined;
}

export function getTrueOrUndefined(check: boolean): true | undefined {
  return getValueOrUndefined(check, true);
}

type SerializerFn = (dt: DateTime) => unknown;

const customDateTimeSerializers: Record<string, SerializerFn> = {
  outageWindowStartUtc: (dt) => dt.toUTC().toLocaleString(DateTime.TIME_24_WITH_SECONDS),
  outageWindowEndUtc: (dt) => dt.toUTC().toLocaleString(DateTime.TIME_24_WITH_SECONDS),
};

function convertDatesToUtcIso(
  obj: unknown,
  path: string = "",
  customSerializers: Record<string, SerializerFn> = {},
  defaultSerializer: SerializerFn = (dt) => dt.toUTC().toISODate()
): unknown {
  if (obj instanceof DateTime) {
    const serializer = customSerializers[path];
    return serializer ? serializer(obj) : defaultSerializer(obj);
  }

  if (Array.isArray(obj)) {
    return obj.map((item) => convertDatesToUtcIso(item, `${path}[]`, customSerializers, defaultSerializer));
  }

  if (obj !== null && typeof obj === "object") {
    const result: Record<string, unknown> = {};
    for (const [key, value] of Object.entries(obj)) {
      const newPath = path ? `${path}.${key}` : key;
      result[key] = convertDatesToUtcIso(value, newPath, customSerializers, defaultSerializer);
    }
    return result;
  }

  return obj;
}

export function convertDateTimesToString(obj: unknown): unknown {
  return convertDatesToUtcIso(obj, "", customDateTimeSerializers);
}
